import { useEffect } from 'react';
import '~/apps/App.css';
import '~/apps/common.css';
import {useInstantSearch} from 'react-instantsearch';
import MenuSelect from "./MenuSelect.js";

function Results({hitsPerPage, indexName}) {
    const {error, results, uiState} = useInstantSearch();

    useEffect(() => {
        if (error) throw error;
    });

    const hasSearchTerm = uiState[indexName] && uiState[indexName].query && uiState[indexName].query.trim().length > 0;
    const hasResults = hasSearchTerm && results && results.nbHits && results.nbHits !== 0;
    const nbHits = results && results.nbHits;

    const departmentUpdateLink = <>
        &nbsp;For Directory of Departments <a href="https://www.sfsu.edu/atoz/">visit A to Z listing</a>
    </>;

    const isAbout = nbHits > 200;

    return hasSearchTerm ?
        (hasResults ?
            <>
                <h2>Search Results</h2>
                <p className="result-summary">
                    Results 1 - {Math.min(hitsPerPage, nbHits)} of {isAbout ? 'about ' : ''}{nbHits} for <q>
                        {uiState[indexName].query}
                    </q>.
                    <br className="hide-sm-up"/>
                    {departmentUpdateLink}
                </p>
                <div className="flex margin-bottom-lg vertical-center">
                    <span className="filter-label">Filter</span>
                    <MenuSelect attribute="positions.csu_working_title" seeAllTitle="Title" limit={30} filter/>
                    <MenuSelect attribute="positions.dept_title" seeAllTitle="Departments" limit={30} filter/>
                </div>
            </> :
            <p className="result-summary">
                There are no results for this query.
                <br className="hide-sm-up"/>
                {departmentUpdateLink}
            </p>
        ) :
        <div className="flex margin-bottom-lg vertical-center">
            <div className="left-align-fill">
                <MenuSelect attribute="positions.dept_title" seeAllTitle="Search by Department" limit={500}/>
            </div>
        <p className="result-summary-with-department-filter">{departmentUpdateLink}</p>
        </div>;
}

export default Results;
